// @ts-strict-ignore
import * as React from 'react';
import { useTrackPageView } from './trackingHelpers';

export const PageViewTrackingWrapper: React.FC<{ pageTitle?: string }> = ({ children, pageTitle }) => {
    useTrackPageView(pageTitle); // tracks a single page view every time the component is mounted

    return <>{children}</>;
};
